import React from 'react';
import { Text, Loader, Box, Flex, UnstyledButton } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import { useExportSurveyActivity } from '../../hooks/useExportSurveyActivity';

interface SurveyActivityDrawerFooterProps {
    surveyId: string;
    activityCount: number;
    loading: boolean;
    hasError: boolean;
    hasActivities: boolean;
}

export function SurveyActivityDrawerFooter({
    surveyId,
    activityCount,
    loading,
    hasError,
    hasActivities,
}: SurveyActivityDrawerFooterProps) {
    const { exportActivityLog, exporting } = useExportSurveyActivity();

    const disabled = exporting || loading || hasError || !hasActivities;

    return (
        <Box className="p-4 border-t border-gray-200 bg-survey-drawer-footer-bg shrink-0 w-full">
            <Flex className="justify-between items-center">
                <Text size="sm" c="dimmed">
                    {activityCount}{' '}
                    {activityCount === 1 ? 'Activity' : 'Activities'} recorded
                </Text>
                <UnstyledButton
                    onClick={() => !exporting && exportActivityLog(surveyId)}
                    disabled={disabled}
                    className="flex items-center gap-1.5 cursor-pointer hover:underline text-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {exporting ? (
                        <Loader size={16} color="blue" />
                    ) : (
                        <IconDownload size={18} />
                    )}
                    <span className="text-sm font-medium">
                        Export Activity Log
                    </span>
                </UnstyledButton>
            </Flex>
        </Box>
    );
}
